<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="空间名称">
              <a-input v-model:value="queryParam.spaceName" placeholder="请输入" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="信标MAC">
              <a-input v-model:value="queryParam.beaconMac" placeholder="请输入" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="责任人">
              <a-input v-model:value="queryParam.userName" placeholder="请输入" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleQuery">搜索</a-button>
              <a-button style="margin-left: 8px" @click="resetQuery">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operations" style="margin-bottom: 16px">
      <a-button type="primary" @click="handleAdd" v-hasPermi="['system:spaceDutyUser:add']">
        新增
      </a-button>
      <a-button
        style="margin-left: 8px"
        :disabled="selectedRowKeys.length === 0"
        @click="handleDelete"
        v-hasPermi="['system:spaceDutyUser:remove']"
      >
        删除
      </a-button>
    </div>

    <create-form ref="createForm" @ok="getList" />

    <a-table
      :loading="loading"
      rowKey="id"
      :columns="columns"
      :data-source="list"
      :row-selection="{ selectedRowKeys, onChange: onSelectChange }"
      :pagination="false"
      :scroll="{ x: 1400 }"
    >
      <template #bodyCell="{ column, record, index }">
        <template v-if="column.dataIndex === 'index'">
          {{ (queryParam.pageNum - 1) * queryParam.pageSize + index + 1 }}
        </template>
        <template v-else-if="column.dataIndex === 'createTime'">
          {{ parseTime(record.createTime) }}
        </template>
        <template v-else-if="column.dataIndex === 'action'">
          <a @click="handleUpdate(record)" v-hasPermi="['system:spaceDutyUser:edit']">编辑</a>
          <a-divider type="vertical" />
          <a @click="handleDelete(record)" v-hasPermi="['system:spaceDutyUser:remove']">删除</a>
        </template>
      </template>
    </a-table>

    <a-pagination
      style="margin-top: 16px; text-align: right"
      v-model:current="queryParam.pageNum"
      v-model:pageSize="queryParam.pageSize"
      :total="total"
      show-size-changer
      :show-total="(t) => `共 ${t} 条`"
      @change="getList"
      @showSizeChange="getList"
    />
  </a-card>
</template>

<script>
import { pageSpaceDutyUser, delSpaceDutyUser } from '@/api/system/spaceDutyUser'
import CreateForm from './modules/CreateForm.vue'

export default {
  name: 'SpaceDutyUser',
  components: { CreateForm },
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      selectedRowKeys: [],
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        projectId: null,
        spaceName: null,
        beaconMac: null,
        userName: null,
      },
      columns: [
        { title: '序号', dataIndex: 'index', width: 70 },
        { title: '空间名称', dataIndex: 'spaceName', width: 140 },
        { title: '空间ID', dataIndex: 'spaceId', width: 180 },
        { title: '信标MAC', dataIndex: 'beaconMac', width: 160 },
        { title: '信标ID', dataIndex: 'beaconId', width: 180 },
        { title: '责任人', dataIndex: 'userName', width: 120 },
        { title: '备注', dataIndex: 'remark', width: 160 },
        { title: '创建时间', dataIndex: 'createTime', width: 180 },
        { title: '操作', dataIndex: 'action', fixed: 'right', width: 140 },
      ],
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.queryParam.projectId = this.$store.getters.currentProjectId
      if (!this.queryParam.projectId) {
        this.$message.warning('请先选择项目')
        this.list = []
        this.total = 0
        return
      }
      this.loading = true
      pageSpaceDutyUser(this.queryParam)
        .then((res) => {
          const page = res && res.data ? res.data : {}
          this.list = page.records || []
          this.total = page.total || 0
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam.spaceName = null
      this.queryParam.beaconMac = null
      this.queryParam.userName = null
      this.handleQuery()
    },
    onSelectChange(keys) {
      this.selectedRowKeys = keys
    },
    handleAdd() {
      if (!this.$store.getters.currentProjectId) {
        this.$message.warning('请先选择项目')
        return
      }
      this.$refs.createForm.handleAdd()
    },
    handleUpdate(record) {
      this.$refs.createForm.handleUpdate(record)
    },
    handleDelete(record) {
      const ids = record && record.id ? [record.id] : this.selectedRowKeys
      if (!ids || ids.length === 0) {
        this.$message.warning('请选择要删除的数据')
        return
      }
      this.$confirm({
        title: '确认删除所选值班配置？',
        onOk: () => {
          return delSpaceDutyUser(ids.map((id) => ({ id }))).then(() => {
            this.$message.success('删除成功')
            this.selectedRowKeys = []
            this.getList()
          })
        },
      })
    },
  },
}
</script>
